import { memo } from 'react'

import { BusinessOutlined, DomainOutlined } from '@mui/icons-material'

import { Chip, ChipProps } from '@collaborate-health/uikit'
import { QualificationVisibilityScope, QualificationVisibilityScopeDisplayName } from '../../enums'

const VisibilityScopeToColorMap: Record<QualificationVisibilityScope, ChipProps['color']> = {
  [QualificationVisibilityScope.Corporation]: 'primary',
  [QualificationVisibilityScope.Tenant]: 'success',
}

const VisibilityScopeToIconMap: Record<QualificationVisibilityScope, ChipProps['icon']> = {
  [QualificationVisibilityScope.Corporation]: <BusinessOutlined />,
  [QualificationVisibilityScope.Tenant]: <DomainOutlined />,
}

export interface QualificationVisibilityScopeChipProps {
  scope: QualificationVisibilityScope
}

const QualificationVisibilityScopeChip: React.FC<QualificationVisibilityScopeChipProps> = ({ scope }) => {
  const color = VisibilityScopeToColorMap[scope] || 'default'
  const icon = VisibilityScopeToIconMap[scope]

  return <Chip label={QualificationVisibilityScopeDisplayName[scope]} size='small' color={color} icon={icon} />
}

export default memo(QualificationVisibilityScopeChip)

